import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { FacetsPage } from 'src/app/facets/facets-page/facets-page.component';
import { ViewCell } from 'ng2-smart-table';

@Component({
  selector: 'app-smart-table-with-badge',
  templateUrl: './smart-table-with-badge.component.html',
  styleUrls: ['./smart-table-with-badge.component.scss'],
})
export class SmartTableWithBadgeComponent
  implements ViewCell, OnInit, OnChanges
{
  @Output() byIconClick = new EventEmitter();
  @Input() value: any; // Value which comes in from the parent component, needs to be parsed.
  @Input() severityInput: string;
  @Input() rowData: any;
  severity;
  background: string;
  showImg: boolean = false;
  isDataValid: boolean = true;
  imgUrl: string = '';
  imgTooltip: string = '';
  badgeClass: string = 'p-2';
  color: string;
  textCase: string = 'uppercase';
  customText: string = '';
  badgeTooltipText: string = '';
  border: string = 'none';
  constructor(activatedRoute: ActivatedRoute) {}

  ngOnInit() {
    this.processInputData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.value?.currentValue) {
      this.processInputData();
    }
  }

  processInputData() {
    if (this.value) {
      try {
        let parsedValue = JSON?.parse(this.value);
        this.severity = parsedValue?.severity;
        this.customText = parsedValue?.customText;
        this.background = parsedValue?.background;
        this.color = parsedValue?.color;
        this.showImg = parsedValue?.showImg ? parsedValue?.showImg : false;
        this.imgUrl = parsedValue?.imgUrl ? parsedValue?.imgUrl : '';
        this.textCase = parsedValue?.textCase || 'uppercase';
        this.badgeClass = parsedValue?.badgeClass
          ? parsedValue?.badgeClass
          : 'p-2';
        this.border = parsedValue?.border;
        this.badgeTooltipText = parsedValue?.badgeTooltipText;
        if (parsedValue?.imgTooltip) {
          this.imgTooltip = parsedValue?.imgTooltip;
        }
      } catch (error) {}
    }
    if (this.severityInput?.length > 0) {
      this.severity = this.severityInput;
    }
    this.isDataValid = this.severity?.length > 0 || this.imgUrl?.length > 0;
  }

  sendEvent() {
    this.byIconClick.emit(this.rowData);
  }
}
